// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1h_py","colCheckbox":"styles_colCheckbox__2-4_E"};